import BugReportRounded from '@mui/icons-material/BugReportRounded'
import { Button, ButtonProps } from '@mui/material'
import { AuthUserPermission } from '../../types'
import { Can } from '../Can'

export const DebugButton = (props: ButtonProps) => {
  return (
    <Can useAny={AuthUserPermission.DEBUG_USER}>
      <Button
        color="secondary"
        variant="outlined"
        {...props}
        startIcon={<BugReportRounded color="error" />}
      />
    </Can>
  )
}
